<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;padding-bottom: 0px;">
          <div class="actionBarStyle">
            <el-row>
                  <div><span style="font-size: 22px;">将各科成绩合并到总成绩单中</span></div>

            </el-row>
            <el-row>
              <el-tooltip class="item" effect="dark" content="新建空成绩单,逐个添加成绩单!" placement="top">
                <el-button type="danger" round @click="howToUse">本功能用途及如何使用本功能?</el-button>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" content="新建空成绩单,逐个添加成绩单!" placement="top">
                <el-button type="primary" round @click="createNewExam">新建总成绩单</el-button>
              </el-tooltip>
              <!--              <el-tooltip class="item" effect="dark" content="导入Excel文件时使用" placement="top">
                <el-button type="primary" round @click="importMutiExcel">导入Excel文件成绩单</el-button>
              </el-tooltip> -->
              <el-link target="_blank" href="http://www.sales1.top/score/files/single_course.xls" :underline="false"
                style="margin-left:15px">
                <!-- <el-button type="warning" round>下载单科模板</el-button> -->
              </el-link>
            </el-row>
          </div>
        </div>
        <div style="padding-left: 10px;padding-right: 10px;color:red;font-size: 14px;">
          成绩单协作码:用于将多个成绩单合并入一个成绩单的识别码。各科老师在手机端将成绩录入好后，在上传成绩单功能中输入该码即可将成绩单合并到一个总成绩单中。</div>
        <div style="padding-left: 10px;padding-right: 10px;margin-top:10px;">

          <el-table border :data="tableData" stripe style="width: 100%;"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="exam_name" label="考试名称">
            </el-table-column>

            <el-table-column prop="grade" label="年级" width="200">
            </el-table-column>
            <el-table-column prop="total_students" label="总数(人)" width="80" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="200" header-align="center" align="center">
            </el-table-column>

            <el-table-column prop="merge_code" label="手机上传成绩单协作码" width="200" header-align="center" align="center">
              <template slot-scope="scope">
                <div><span style="color:red;font-weight: bold;font-size: 20px;">{{scope.row.merge_code}}</span></div>
                <div>复制数字后</div>
                <div>发给需上传成绩的老师</div>
              </template>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="120">
              <template slot-scope="scope">
                <div class="actionStyle">
                  <div>
                    <el-button @click.native.prevent="viewExam(scope.$index, tableData)" type="text" size="small">
                      查看成绩单
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="editExam(scope.$index, tableData)" type="text" size="small">
                      修改考试信息
                    </el-button>
                  </div>
                  <div>
                    <el-button @click.native.prevent="delExam(scope.$index, tableData)" type="text" size="small">
                      删除成绩单
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="importExam(scope.$index, tableData)" type="text" size="small">
                      <span style="color:red;">导入Excel成绩单</span>
                    </el-button>
                  </div>

                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total, prev, pager, next" :total="total_record" :page-size="pageSize">
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>{{msg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="delExamRecord">删 除</el-button>
      </span>
    </el-dialog>

    <!--成绩导入成功提示-->
    <el-dialog width="80%" :close-on-click-modal="false" title='成绩导完后要让大家能查需要"两步走"'
      :visible.sync="successDialogVisible">
      <!-- <el-form-item label="卷面分"> -->
      <div class="colStyle">
        <div style="font-size: 16px;">
          <span
            style="font-weight: bold;">第一步:转发快查成绩小程序。</span>要让大家能查询到，需要将“快查成绩”小程序分享到群里,手机扫下面的码打开小程序,要分享到微信群扫左侧的,QQ群扫右侧的。
        </div>
        <div class="imageStyle">
          <div class="imgItemStyle" style="padding-right: 10px;"><img
              src="https://www.sales1.top/score/images/weixin.jpg" width="150px;" />
            <div>微信群分享扫这个</div>
          </div>
          <div class="imgItemStyle" style="padding-left: 10px;"><img src="https://www.sales1.top/score/images/QQ.png"
              width="150px;" />
            <div>QQ群分享扫这个</div>
          </div>
        </div>

        <div style="padding-top: 10px;">
          扫码后会打开小程序,小程序右上角点<font color="red">"转发"</font>转发到群里即可完成小程序发放操作。
        </div>

        <div style="padding-top: 10px;font-size: 16px;">
          <span
            style="font-weight: bold;">第二步：转发学生姓名和学号对应表。</span>打开手机端“快查成绩”小程序，登录后并点开您刚导入的成绩单，点击“导出学号”可以导出姓名和学号对应的Excel表格，然后把表格分享到家长群中即可。
        </div>
        <div style="color: red;margin-top: 20px;">
          注意：1个手机只能查1个人的成绩,查询成功后会锁定在第一次查询的学生上。为了避免学生利用公开的姓名和学号对应关系解锁后查询别人的成绩，请将学号私发给学生和家长，并让其保密。</div>
        <!--        <div>
          <div class="imgItemStyle">
            <el-image style="width: 100px; height: 100px" :src="qrcode_img_url" :fit="fit"></el-image>
            <div>扫这个码下载姓名学号对应表</div>
            <div style="color: red;">如果看不到二维码刷新页面后再试</div>
          </div>
        </div> -->

        <!-- </div> -->
      </div>

      <!-- </el-form-item> -->

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="cacelSetPaperScore">取 消</el-button> -->
        <el-button type="primary" @click="successDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!--如何使用本功能-->
    <el-dialog title="怎么使用成绩单合并功能？" :visible.sync="howToUserMergeExamDialogVisible" width="50%">
      <div>
        <div>
          <div style="font-weight: bold;margin-top: 10px;font-size: 18px;">这个功能有什么用?</div>
          <div style="margin-top: 10px;font-size: 16px;">将多个科目成绩合并到一个成绩单中，方便下一步成绩分析.</div>
        </div>
        <div>
          <div style="font-weight: bold;margin-top: 10px;font-size: 18px;">各个老师成绩已经录入了Excel时怎么使用?</div>
          <div style="margin-top: 10px;font-size: 16px;">1.各科老师在excel中录入成绩,成绩单里必须有<span style="color:red;">姓名和学号(考号等)</span>.</div>
          <div style="margin-top: 10px;font-size: 16px;">2.各科老师把excel成绩单发给合并成绩的老师,老师在这里新建一个空成绩单，把各科老师的成绩单导入即可合并成绩单.</div>
          <div style="margin-top: 10px;font-size: 16px;">3.下载合并好的成绩单即可.</div>
        </div>

        <div>
          <div style="font-weight: bold;margin-top: 10px;font-size: 18px;">每个学生的成绩还在卷子上怎么使用?</div>
          <div style="margin-top: 10px;font-size: 16px;">1.各科老师在手机小程序上录入各自的成绩单.</div>
          <div style="margin-top: 10px;font-size: 16px;">2.合并成绩的老师把成绩单协作码告诉TA.</div>
          <div style="margin-top: 10px;font-size: 16px;">3.老师录好成绩用“上传成绩”功能将成绩上传到总成绩单中,成绩单导出即可使用.</div>
        </div>

        <div>
          <div style="font-weight: bold;margin-top: 10px;font-size: 18px;">怎么用好这个功能?</div>
          <div style="margin-top: 10px;font-size: 16px;">1.把姓名学号对应的表格做好发给各位老师.</div>
          <div style="margin-top: 10px;font-size: 16px;">2.各位老师录自己科目的成绩(可以用电脑excel也可以用小程序录入).</div>
          <div style="margin-top: 10px;font-size: 16px;">3.各位老师上传自己的成绩单到总成绩单中.</div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="howToUserMergeExamDialogVisible = false" type="primary">知道了</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        dateList: ['全部'],
        filterCondition: '',
        students: [],
        username: '',
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,

        shownotify: 0,
        successDialogVisible: false,

        showScoreAvg: false,
        showSection: false,
        showAvgTrend: false,
        unlockDialogVisible: false,
        unlockForm: {
          student_name: '',
          student_num: ''
        },

        img_url: '',

        setSearchStatedialogVisible: false,
        setSearchStateDialogTitle: '',
        setSearchStateBtn: '',
        setSearchStateInfo: '',

        total_record: 0,
        pageSize: 10,

        howToUserMergeExamDialogVisible: false

      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.loadSetting()
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME') // 获取session
      // this.username = this.$route.params.username

      // this.loadDateList()
      this.loadData()
    },
    methods: {

      loadData() {
        // console.log('加载数据')
        // let that = this

        // // 开启loading
        // const load = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })

        // var requestUrl = '/score/web/_load_exams.jsp'
        // this.axios.get(requestUrl, {
        //     params: {
        //       username: that.username,
        //       filter_date: that.filterCondition
        //     }
        //   }).then(function(response) {
        //     that.tableData = response.data
        //     load.close()

        //     // 导出学生清单
        //     that.exportStudents()
        //   })
        //   .catch(function(error) {
        //     console.log(error)
        //     load.close()
        //   })this.handleCurrentChange(1)

        this.handleCurrentChange(1)
      },
      indexMethod() {
        this.index++
        return this.index
      },
      convertPaperScore(course, paperScore) {
        if (course === '总分' || course.indexOf('排名') >= 0) {
          return '/'
        } else {
          return paperScore
        }
      },
      viewExam(index, rows) {
        // rows.splice(index, 1);

        var examID = rows[index].id
        // var course = rows[index].course
        var exam = rows[index].exam_name

        console.log('查看成绩单:' + exam)

        this.$router.push({
          name: 'team_exam_detail',
          params: {
            id: examID,
            // course: course,
            exam_name: exam
          }
        })
      },
      delExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id

        this.msg = '确定要删除"' + rows[index].exam_name + '"成绩单吗?'

        this.dialogVisible = true
      },
      delExamRecord() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: '正在删除,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        that.dialogVisible = false
        // 调用删除接口
        var requestUrl = '/score/web/_team_delete_exam_and_score.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            // that.tableData.splice(that.position, 1)
            // that.loadDateList()
            that.loadData()

            that.dialogVisible = false
            load.close()
            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        var examName = rows[index].exam_name
        var grade = rows[index].grade

        console.log('examName=', examName)

        let that = this

        this.$router.push({
          name: 'team_exam_new',
          params: {
            id: that.selectedExamID,
            exam_name: examName,
            grade: grade,
            operation: 'EDIT'
          }
        })
      },
      importExcel() {
        this.$router.push('/exam_import')
      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/team_exam_new')
      },
      searchSettingExam(index, rows) {
        let that = this

        this.position = index
        this.selectedExamID = rows[index].id

        // 加载状态
        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_load_settings.jsp'
        this.axios.get(requestUrl).then(function(response) {
            console.log(response.data)

            that.configurations = response.data

            if (response.data === null || response.data.length === 0) {
              that.showPosition = false
              // console.log('************')
            } else {
              for (var i = 0; i < that.configurations.length; i++) {
                console.log(that.configurations[i])
                if (that.configurations[i].setting_name === 'show_position') {
                  console.log(that.configurations[i].setting_value)

                  if (that.configurations[i].setting_value === '1') {
                    that.showPosition = true
                  } else {
                    that.showPosition = false
                  }

                  break
                }
              }
            }

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })

        this.searchResultSettingDialogTableVisible = true
      },
      saveSettings() {
        let intShowScoreAvg = 0
        if (this.showScoreAvg === true) {
          intShowScoreAvg = 1
        }

        let intShowSection = 0
        if (this.showSection === true) {
          intShowSection = 1
        }

        let intShowAvgTrend = 0
        if (this.showAvgTrend === true) {
          intShowAvgTrend = 1
        }

        let that = this

        console.log(intShowScoreAvg + ':' + intShowSection + ':' + intShowAvgTrend)

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_update_show_setting.jsp'
        this.axios.get(requestUrl, {
            params: {
              intShowScoreAvg: intShowScoreAvg,
              intShowSection: intShowSection,
              intShowAvgTrend: intShowAvgTrend,
              username: that.username
            }
          }).then(function(response) {
            console.log(response.data.result)
            that.$message.success('参数设置成功！')
            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })

        this.searchResultSettingDialogTableVisible = false
      },

      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this

        this.position = index
        this.selectedExamID = rows[index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            that.students = response.data
            that.unReadDialogFormVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      loadSetting() {
        let that = this
        var requestUrl = '/score/web/_load_settings.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            let list = response.data

            console.log(list)

            for (var i = 0; i < list.length; i++) {
              var settingName = list[i].setting_name
              var settingValue = list[i].setting_value

              console.log(settingName + '=' + settingValue)

              if (settingName === 'intShowScoreAvg') {
                if (settingValue === '1') {
                  that.showScoreAvg = true
                } else {
                  that.showScoreAvg = false
                }
              }

              if (settingName === 'intShowSection') {
                if (settingValue === '1') {
                  that.showSection = true
                } else {
                  that.showSection = false
                }
              }

              if (settingName === 'intShowAvgTrend') {
                if (settingValue === '1') {
                  that.showAvgTrend = true
                } else {
                  that.showAvgTrend = false
                }
              }
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      closeSettings() {
        this.searchResultSettingDialogTableVisible = false
        this.loadSetting()
      },
      unlockPhone() {
        this.unlockDialogVisible = true
      },
      unlockAllPhone() {
        let that = this

        this.$confirm('确定要解锁所有手机吗?', '操作提醒', {
          confirmButtonText: '全部解锁',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_unlock_all.jsp'
          this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            console.log(response)

            if (response.data.result === '1') {
              that.$message.success('解锁成功！！')
            } else {
              that.$message.error(response.data.message)
            }

            load.close()
          }).catch(function(error) {
            console.log(error)
            load.close()
          })
        }).catch(() => {

        })
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      unlock() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_unlock.jsp'
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            student_name: that.unlockForm.student_name,
            student_num: that.unlockForm.student_num
          }
        }).then(function(response) {
          console.log(response)

          if (response.data.result === '1') {
            that.$message.success('解锁成功！！')
          } else {
            that.$message.error(response.data.message)
          }

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })

        this.unlockDialogVisible = false
      },
      exportStudents() {
        let that = this

        var qrcodeRequestUrl = '/score/web/_qrcode.jsp'
        this.axios.get(qrcodeRequestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            let tmpFile = response.data.filename
            that.qrcode_img_url = '/score' + tmpFile
            console.log(this.qrcode_img_url)
          })
          .catch(function(error) {
            console.log(error)
          })

        var requestUrl = '/score/web/_export_students_to_excel.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            console.log(response.data)
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      convertPostion(index) {
        if (index === 0) {
          return '显示'
        } else {
          return '不显示'
        }
      },
      pointSetting(index, rows) {
        this.selectedExamID = rows[index].id
        var exam_name = rows[index].exam

        this.$router.push({
          name: 'point_setting',
          params: {
            id: this.selectedExamID,
            exam_name: exam_name
          }
        })
      },
      setSearchState(index, rows, state) {
        this.selectedExamID = rows[index].id

        if (state === 1) {
          this.setSearchStateInfo = '可查询'
          this.setSearchStateBtn = '关闭查询'
        } else {
          this.setSearchStateInfo = '不可查询'
          this.setSearchStateBtn = '修改'
          this.setSearchStateBtn = '打开查询'
        }

        this.setSearchStateDialogTitle = '修改查询状态'
        this.setSearchStatedialogVisible = true
      },
      updateSearchState() {
        var search_state = 1
        if (this.setSearchStateBtn == '关闭查询') {
          search_state = 0
        }

        let that = this

        var qrcodeRequestUrl = '/score/web/_update_search_state.jsp'
        this.axios.get(qrcodeRequestUrl, {
            params: {
              username: that.username,
              exam_key: that.selectedExamID,
              search_state: search_state
            }
          }).then(function(response) {
            that.setSearchStatedialogVisible = false
            that.loadData()
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      handleCurrentChange(currentPage) {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_team_load_exams.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              filter_date: that.filterCondition,
              current_page: currentPage,
              page_size: that.pageSize,
              condition: that.condition
            }
          }).then(function(response) {
            that.tableData = response.data.team_exams
            load.close()

            that.total_record = response.data.total_record

            // 导出学生清单
            that.exportStudents()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      importExam(index, rows) {
        this.selectedExamID = rows[index].id

        console.log('this.selectedExamID =',this.selectedExamID )

        let that = this
        this.$router.push({
          name: 'team_exam_import_anyfile',
          params: {
            exam_id: that.selectedExamID
          }
        })
      },
      howToUse() {
        this.howToUserMergeExamDialogVisible = true
      }

    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/team_exam_list.vue